'use client';
import { motion } from 'framer-motion';
import gsap from 'gsap';
import { useEffect, useRef, useState } from 'react';
import Project from './components/project';
import styles from './style.module.scss';

const projects = [
	{
		title: 'Avionics Categories',
		src: 'c2montreal.png',
		color: '#d4e09b',
		contents:
			'COM, NAV, FMS, PFD, MFD, EICAS, Weather and Radar Systems, Audio Panels and Intercoms, TCAS/ADS-B, TAWS/GPWS.',
	},
	{
		title: 'Engine Rotor Components (Turbine & Compressor)',
		src: 'officestudio.png',
		color: '#f6f4d2',
		contents:
			'Compressor Disks & Spools, Turbine Disks (HPT/LPT), Fan Disks and Hubs, Main Engine Shafts, Compressor Spacers and Seals, Engine Casings, Main Engine Mounts.',
	},
	{
		title: 'Airframe and Landing Gear LLPs',
		src: 'locomotive.png',
		color: '#cbdfbd',
		contents:
			'Landing Gear Main Struts & Beams, Axles, Wing Spar Components, APU Turbine Disks, Main Rotor Blade Spars.',
	},
	{
		title: 'Landing Gear Categories',
		src: 'silencio.png',
		color: '#f19c79',
		contents:
			'Main and Nose Gear Actuators, Wheels and Brake Assemblies, Tires and Tubes, Steering Control Units, Landing Gear Doors and Fairings, Axles and Sleeves, Locking Pins and Latches, Hydraulic Lines and Manifolds.',
	},
];

const scaleAnimation = {
	initial: { scale: 0, x: '-50%', y: '-50%' },
	enter: {
		scale: 1,
		x: '-50%',
		y: '-50%',
		transition: { duration: 0.4, ease: [0.76, 0, 0.24, 1] },
	},
	closed: {
		scale: 0,
		x: '-50%',
		y: '-50%',
		transition: { duration: 0.4, ease: [0.32, 0, 0.67, 0] },
	},
};

export default function Home() {
	const [modal, setModal] = useState({ active: false, index: 0 });
	const { active, index } = modal;
	const modalContainer = useRef(null);
	const cursor = useRef(null);
	const cursorLabel = useRef(null);

	let xMoveContainer = useRef(null);
	let yMoveContainer = useRef(null);
	let xMoveCursor = useRef(null);
	let yMoveCursor = useRef(null);
	let xMoveCursorLabel = useRef(null);
	let yMoveCursorLabel = useRef(null);

	useEffect(() => {
		//Move Container
		xMoveContainer.current = gsap.quickTo(modalContainer.current, 'left', {
			duration: 0.8,
			ease: 'power3',
		});
		yMoveContainer.current = gsap.quickTo(modalContainer.current, 'top', {
			duration: 0.8,
			ease: 'power3',
		});
		//Move cursor
		xMoveCursor.current = gsap.quickTo(cursor.current, 'left', {
			duration: 0.5,
			ease: 'power3',
		});
		yMoveCursor.current = gsap.quickTo(cursor.current, 'top', {
			duration: 0.5,
			ease: 'power3',
		});
		//Move cursor label
		xMoveCursorLabel.current = gsap.quickTo(cursorLabel.current, 'left', {
			duration: 0.45,
			ease: 'power3',
		});
		yMoveCursorLabel.current = gsap.quickTo(cursorLabel.current, 'top', {
			duration: 0.45,
			ease: 'power3',
		});
	}, []);

	const moveItems = (x, y) => {
		xMoveContainer.current(x);
		yMoveContainer.current(y);
		xMoveCursor.current(x);
		yMoveCursor.current(y);
		xMoveCursorLabel.current(x);
		yMoveCursorLabel.current(y);
	};
	const manageModal = (active, index, x, y) => {
		moveItems(x, y);
		setModal({ active, index });
	};

	return (
		<main
			onMouseMove={(e) => {
				moveItems(e.clientX, e.clientY);
			}}
			className={styles.projects}
		>
			<div className={styles.body}>
				{projects.map((project, index) => {
					return (
						<Project
							index={index}
							title={project.title}
							manageModal={manageModal}
							key={index}
						/>
					);
				})}
			</div>
			{/* <Rounded>
				<p>More work</p>
			</Rounded> */}
			<>
				<motion.div
					ref={modalContainer}
					variants={scaleAnimation}
					initial="initial"
					animate={active ? 'enter' : 'closed'}
					className={styles.modalContainer}
				>
					<div
						style={{ top: index * -100 + '%' }}
						className={styles.modalSlider}
					>
						{projects.map((project, index) => {
							const { src, color, contents } = project;
							return (
								<div
									className={styles.modal}
									style={{ backgroundColor: color }}
									key={`modal_${index}`}
								>
									{/* <Image
										src={`/images/${src}`}
										width={300}
										height={0}
										alt="image"
									/> */}
									<p>{contents}</p>
								</div>
							);
						})}
					</div>
				</motion.div>
				{/* <motion.div
					ref={cursor}
					className={styles.cursor}
					variants={scaleAnimation}
					initial="initial"
					animate={active ? 'enter' : 'closed'}
				></motion.div>
				<motion.div
					ref={cursorLabel}
					className={styles.cursorLabel}
					variants={scaleAnimation}
					initial="initial"
					animate={active ? 'enter' : 'closed'}
				>
					View
				</motion.div> */}
			</>
		</main>
	);
}
